module.exports = __webpack_public_path__ + "static/media/Digital Health Card.7dde2a71.svg";